import { exchange } from "@ls/js-fetch";
import { compareValues } from "@ls/js-utils";
import { throwError } from "@ls/error-module";
import { selectScenarioEntity } from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
const jsFetchExchange = exchange;
export const REQUEST_INVEST_PLATFORM = "scenario/REQUEST_INVEST_PLATFORM";
export const RECEIVE_INVEST_PLATFORM = "scenario/RECEIVE_INVEST_PLATFORM";
export const requestUserInvestPlatform = (uid) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_INVEST_PLATFORM });
    const result = (
      await jsFetchExchange({
        dontSendBearerToken: true,
        baseURL: process.env.REACT_APP_BASE_URL_TS,
        // url: 'rest/fidrdata/investapplicationplatform/user',
        url: "rest/fidrdata/investapplicationplatformlistcsv/user",
        params: {
          uid,
        },
      })
    )?.data;

    dispatch({ type: RECEIVE_INVEST_PLATFORM, value: result });
  };
};

export const REQUEST_SCENARIO_OPTIONS = "scenario/REQUEST_SCENARIO_OPTIONS";
export const RECEIVE_SCENARIO_OPTIONS = "scenario/RECEIVE_SCENARIO_OPTIONS";
export const requestScenarioOptions = (investGroupId) => {
  return async (dispatch) => {
    if (investGroupId === null || investGroupId === undefined) {
      dispatch({ type: RECEIVE_SCENARIO_OPTIONS, value: [] });
      console.warn("Investment Group ID is not defined for this user.");
      // throwError({
      //   title: "Scenario Error",
      //   message: "Investment Group ID is not defined for this user.",
      // });
      return;
    }
    dispatch({ type: REQUEST_SCENARIO_OPTIONS });
    let data;
    let error;
    try {
      data = (
        await jsFetchExchange({
          baseURL: process.env.REACT_APP_BASE_URL_TDS,
          url: "rest/uss/userScenarios/byInvestmentGroupIdandScenarioStateAndDateName",
          params: {
            investGroupId,
            scenarioState: "ALL",
            dateRange: "lastThreeMonths",
          },
        })
      )?.data;
    } catch (e) {
      data = [];
      error = e;
    }
    dispatch({
      type: RECEIVE_SCENARIO_OPTIONS,
      value: data
        .map(({ name, id }) => ({ label: name, value: id }))
        .sort(compareValues("label")),
    });
    if (error) {
      throwError({
        title: "Scenario Error",
        message: JSON.stringify(error?.message ?? error),
      });
      console.warn("Scenario Error:", error);
    }
  };
};

export const SET_ENTITY_IDS = "scenario/SET_ENTITY_IDS";
export const setScenarioEntityIds = (entityIds) => {
  return {
    type: SET_ENTITY_IDS,
    value: entityIds,
  };
};
export const SET_RESPONSE_ENTITY_IDS = "scenario/SET_RESPONSE_ENTITY_IDS";
export const setResponseEntityIds = (entityIds) => {
  return {
    type: SET_RESPONSE_ENTITY_IDS,
    value: entityIds,
  };
};

export const REQUEST_SCENARIO_ENTITY_IDS =
  "scenario/REQUEST_SCENARIO_ENTITY_IDS";
export const RECEIVE_SCENARIO_ENTITY_IDS =
  "scenario/RECEIVE_SCENARIO_ENTITY_IDS";
export const fetchScenarioEntityIds = (scenarioValue) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_SCENARIO_ENTITY_IDS });
      const result = (
        await exchange({
          baseURL: process.env.REACT_APP_BASE_URL_TDS,
          url: "rest/uss/getScenarioEntityIds",
          params: {
            scenarioName: scenarioValue,
          },
        })
      )?.data;
      dispatch({ type: RECEIVE_SCENARIO_ENTITY_IDS });
      return result;
    } catch (e) {
      dispatch({ type: RECEIVE_SCENARIO_ENTITY_IDS });
      throwError({
        title: `${process.env.REACT_APP_BASE_URL_TDS}`,
        message: JSON.stringify(e),
      });
      return [];
    }
  };
};

export const fecthAsOfDate = (workspaceName) => {
  return async () => {
    try {
      const result = (
        await exchange({
          baseURL: process.env.REACT_APP_BASE_URL_TDS,
          url: "/rest/uss/getScenarioCustomAsOfDate",
          params: {
            scenarioName: workspaceName,
          },
        })
      )?.data;
      return result;
    } catch (e) {
      throwError({
        title: `${process.env.REACT_APP_BASE_URL_TDS}`,
        message: JSON.stringify(e),
      });
      return [];
    }
  };
};
export const REQUEST_SCENARIO_STATE = "scenario/REQUEST_SCENARIO_STATE";
export const RECEIVE_SCENARIO_STATE = "scenario/RECEIVE_SCENARIO_STATE";
export const fetchScenarioState = (scenarioValue) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_SCENARIO_STATE });
      const result = (
        await exchange({
          baseURL: process.env.REACT_APP_BASE_URL_TDS,
          url: "rest/uss/getScenarioState",
          params: {
            scenarioName: scenarioValue,
          },
        })
      )?.data;
      dispatch({ type: RECEIVE_SCENARIO_STATE });
      return result;
    } catch (e) {
      dispatch({ type: RECEIVE_SCENARIO_STATE });
      throwError({
        title: `${process.env.REACT_APP_BASE_URL_TDS}`,
        message: JSON.stringify(e),
      });
      return null;
    }
  };
};

export const REQUEST_SUBMIT_SCENARIO_ENTITIES =
  "scenario/REQUEST_SUBMIT_SCENARIO_ENTITIES";
export const RECEIVE_SUBMIT_SCENARIO_ENTITIES =
  "scenario/RECEIVE_SUBMIT_SCENARIO_ENTITIES";
export const submitScenarioEntities = (
  destinationScenarioName,
  entityIds,
  uid
) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REQUEST_SUBMIT_SCENARIO_ENTITIES });
      const state = getState();
      const selectedScenarioEntity = selectScenarioEntity(
        SelectionState.COMMITTED
      )(state);
      const scenarioId = await fetchScenarioId(selectedScenarioEntity.value);
      const response = await exchange({
        baseURL: process.env.REACT_APP_BASE_URL_IN2_RISKTREE,
        url: "/USERSCENARIOOPTIMIZER?crd_mgr=ATF_BOSTON&crd_trdr=ATF_BOSTON&crd_basket=ATF_BOSTON&scenarioAction=releaseAndSendAccountTrades&isJson=true",
        method: "POST",
        data: {
          sendreleasedata: {
            user_scenario_id: scenarioId,
            user_scenario_name: selectedScenarioEntity.label,
            destination_user_scenario_name: destinationScenarioName,
            entityIds: entityIds.join(","),
            uid: uid,
            scenarioAction: "releaseAndSendAccountTrades",
            donotcacheURL: true,
            crd_basket: "ATF_BOSTON",
            crd_trdr: "ATF_BOSTON",
            crd_mgr: "ATF_BOSTON",
          },
        },
      });
      dispatch({ type: RECEIVE_SUBMIT_SCENARIO_ENTITIES });
      return response.data;
    } catch (e) {
      console.error(e);
      dispatch({ type: RECEIVE_SUBMIT_SCENARIO_ENTITIES });
      throwError({
        title: `Error: ${process.env.REACT_APP_BASE_URL_IN2_RISKTREE}`,
        message: JSON.stringify(e),
      });
      return false;
    }
  };
};

export const REQUEST_DELETE_SCENARIO_ENTITIES =
  "scenario/REQUEST_DELETE_SCENARIO_ENTITIES";
export const RECEIVE_DELETE_SCENARIO_ENTITIES =
  "scenario/RECEIVE_DELETE_SCENARIO_ENTITIES";
export const deleteScenarioEntities = (scenarioValue, entityIds, uid) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_DELETE_SCENARIO_ENTITIES });
      const scenarioId = await fetchScenarioId(scenarioValue);
      const resp = await exchange({
        baseURL: process.env.REACT_APP_BASE_URL_TDS,
        url: `rest/uss/userScenarios/deleteAllUserScenarioMultiEntitySecurities`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: Object.entries({
          scenarioId,
          entityIds,
          uid,
        })
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join("&"),
      });
      dispatch({ type: RECEIVE_DELETE_SCENARIO_ENTITIES });
      return resp.status === 200;
    } catch (e) {
      dispatch({ type: RECEIVE_DELETE_SCENARIO_ENTITIES });
      throwError({
        title: `${process.env.REACT_APP_BASE_URL_TDS}`,
        message: JSON.stringify(e),
      });
      return false;
    }
  };
};

const fetchScenarioId = async (scenarioValue) => {
  const scenarioId = (
    await exchange({
      baseURL: process.env.REACT_APP_BASE_URL_TDS,
      url: "rest/uss/userScenarios/getScenarioId",
      params: {
        scenarioName: scenarioValue,
      },
    })
  )?.data;
  if (scenarioId === undefined || scenarioId === null) {
    throw new Error("Scenario ID not found");
  }

  return scenarioId;
};
